"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.usCdnHostUrl = exports.euCdnHostUrl = exports.sgAndVacdnHostUrl = exports.boeCdnHostUrl = exports.formalHost = exports.boeHost = void 0;
exports.boeHost = ['osc-boe', 'bytedance', 'net'];
exports.formalHost = ['osc', 'tiktok-row', 'net'];
exports.boeCdnHostUrl = ['tosv', 'boei18n', 'byted', 'org'];
exports.sgAndVacdnHostUrl = ['sf-oec-config-center', 'tiktokcdn', 'com'];
exports.euCdnHostUrl = ['sf-oec-config-center', 'tiktokcdn-eu', 'com'];
exports.usCdnHostUrl = ['sf-oec-config-center', 'tiktokcdn-us', 'com'];